import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const useApproveConfirmation = (
  isLoading,
  hasBIN,
  isStartAssessment,
  transactionStatus,
  onYesCallBack,
  onNoCallback = () => {}
) => {
  const isAllowed = true;

  const isStatusAllowed = ['COMPUTED'].indexOf(transactionStatus) > -1;

  const showComponent =
    isAllowed && isStartAssessment && hasBIN && isStatusAllowed;

  const onHandleClick = (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want approve this application?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const component = showComponent ? (
    <button
      disabled={isLoading}
      onClick={onHandleClick}
      type="button"
      className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
    >
      {isLoading && (
        <>
          <i className="fas fa-spinner fa-spin" />
          &nbsp;
        </>
      )}
      Approve
    </button>
  ) : null;

  return {
    isAllowed,
    onHandleClick,
    component,
  };
};

export default useApproveConfirmation;
